/* PromotionsList.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _2 = "._otyrv47k{margin-bottom:var(--ds-space-250,20px)}";
import EmptyState from '@atlaskit/empty-state';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { GenericErrorImage, TabHeader } from '@atlassian/developer-space';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { useHistory } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { ANALYTICS_SUBJECT_ID_CREATE_PROMOTION } from '../../../analytics/Events';
import { createPromotionRoute } from '../../../constants/Routes';
import { resolveManagePartnersRoutes } from '../../../utils/routeUtils';
import { formatPartnerAppsOptions, formatPartnerHostingTypesOptions, usePartnerAppsAndHosting, usePromotions } from './hooks';
import PromotionsFilter from './PromotionsFilter';
import PromotionsListSectionMessage from './PromotionsListSectionMessage';
import PromotionsTable from './PromotionsTable';
import PromotionsCloudTable from './PromotionsTable/CloudPromotions/PromotionsCloudTable';
const _ = "._8k75jp4b td{vertical-align:top}";
export const Section = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "section",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_8k75jp4b", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Section.displayName = 'Section';
}
const SectionMessageWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_otyrv47k", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionMessageWrapper.displayName = 'SectionMessageWrapper';
}
// eslint-disable-next-line max-lines-per-function
const PromotionsList = props => {
  const history = useHistory();
  const {
    enableServerEos
  } = useFeatureFlags();
  const [filters, onChangeFilters] = useState([]);
  const [pageNumber, onChangePageNumber] = useState(1);
  const [sortBy, onChangeSortBy] = useState({
    orderBy: '',
    orderAsc: false
  });
  const [nextId, _setNextId] = useState(null);
  const [prevId, _setPrevId] = useState(null);
  const {
    promotionsData,
    pending,
    error
  } = usePromotions(props.mpacBaseUrl, props.partnerId, filters, sortBy, (pageNumber - 1) * 10, nextId, prevId);
  const isCloudHostingFilterFound = filters.some(result => {
    if (result.type === 'HOSTING' && result.value === 'CLOUD') {
      return true;
    }
    return false;
  });
  const resetFirstPage = () => {
    _setNextId(null);
    _setPrevId(null);
  };
  const {
    partnerAppsAndHosting
  } = usePartnerAppsAndHosting(props.mpacBaseUrl, props.partnerId);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const goToCreatePromotionPage = () => {
    history.push(resolveManagePartnersRoutes(createPromotionRoute.path, {
      partnerId: props.partnerId
    }));
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_CREATE_PROMOTION,
      attributes: {
        partnerId: props.partnerId
      }
    });
  };
  if (error) {
    // TODO: Add the commonized error page
    return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(EmptyState, {
      header: "We ran into a little trouble",
      description: "It might just be a hiccup. Try again in a bit.",
      imageUrl: GenericErrorImage
    }));
  }
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Promotions",
    ctaText: "Create Promotion",
    onCTAClick: goToCreatePromotionPage
  }), enableServerEos && /*#__PURE__*/React.createElement(SectionMessageWrapper, null, /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "warning",
    actions: /*#__PURE__*/React.createElement(SectionMessageAction, {
      href: "https://developer.atlassian.com/platform/marketplace/knowledge-base/end-of-sale-and-support-for-server-apps/"
    }, "Learn more")
  }, /*#__PURE__*/React.createElement("p", null, "As we continue to move towards a cloud future together, creation of promotions for server apps is no longer available for partners, except for Fisheye and Crucible."))), /*#__PURE__*/React.createElement(PromotionsListSectionMessage, {
    partnerId: props.partnerId,
    promotions: promotionsData ? promotionsData.promotions : []
  }), /*#__PURE__*/React.createElement(PromotionsFilter, {
    filters: filters,
    onChange: onChangeFilters,
    resetFirstPage: resetFirstPage,
    setPageNumber: onChangePageNumber,
    onChangeSortBy: onChangeSortBy,
    apps: formatPartnerAppsOptions(partnerAppsAndHosting),
    hostingTypes: formatPartnerHostingTypesOptions(partnerAppsAndHosting)
  }), !isCloudHostingFilterFound ? /*#__PURE__*/React.createElement(PromotionsTable, {
    promotions: promotionsData ? promotionsData.promotions : [],
    totalItems: promotionsData !== null && promotionsData !== void 0 && promotionsData.totalItems ? promotionsData.totalItems : 0,
    pageNumber: pageNumber,
    setPageNumber: onChangePageNumber,
    sortBy: sortBy,
    onChangeSortBy: onChangeSortBy,
    filters: filters,
    isLoading: pending,
    partnerId: props.partnerId
  }) : /*#__PURE__*/React.createElement(PromotionsCloudTable, {
    promotions: promotionsData ? promotionsData.promotions : [],
    totalItems: promotionsData !== null && promotionsData !== void 0 && promotionsData.totalItems ? promotionsData.totalItems : 0,
    prevId: promotionsData === null || promotionsData === void 0 ? void 0 : promotionsData.prevId,
    setPrevId: () => {
      _setPrevId(promotionsData === null || promotionsData === void 0 ? void 0 : promotionsData.prevId);
      _setNextId(null);
    },
    nextId: promotionsData === null || promotionsData === void 0 ? void 0 : promotionsData.nextId,
    setNextId: () => {
      _setNextId(promotionsData === null || promotionsData === void 0 ? void 0 : promotionsData.nextId);
      _setPrevId(null);
    },
    resetFirstPage: resetFirstPage,
    sortBy: sortBy,
    onChangeSortBy: onChangeSortBy,
    filters: filters,
    isLoading: pending,
    partnerId: props.partnerId
  }));
};
export default PromotionsList;